import { getMonthName } from '../../core/helper/month';

export class InvoicePeriodItem {
  constructor() {}

  month: number;
  monthName: string;
  year: number;

  toId() {
    return `${this.year ? this.year : ''}${this.month ? this.month : ''}`;
  }

  toJSON() {
    return { month: this.month, year: this.year };
  }
}
